// src/NewPage.js
import React from 'react';
const Footer = () => {
    return (
        <div className="footer2 hidden-print row EL-footer2" style={{paddingTop: "20px"}}>
            <link rel="stylesheet" href="/static/css/1717421276.footer.min.css"/>
            <div className="col-12 col-md-3">
                <h3>需要帮助?</h3>
                <div>
                    <a className="footer-questions-gtm q-and-a-link-gtm" href="https://blog.datarabbit.com.cn/aboutus">关于我们</a>
                </div>
                <div style={{padding: '10px 0 20px 0'}}>
                    <a className="footer-fredhelp-gtm" href="javascript:void">DataRabbit 帮助</a>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="col-12"
                     style={{textAlign: 'center', display: 'grid', height: '100%', alignItems: 'center'}}>
                    <a href="https://beian.miit.gov.cn/" target="_blank">
                        <img src="/static/images/be.png" style={{width: 18, position: 'relative', left: '-5px', top: '-1px'}}/>蜀ICP备2024083246号-2</a>
                    <a href="https://www.stats.gov.cn/">国家统计局</a>
                </div>
            </div>
            <hr className="d-md-none" style={{border: 'none'}}/>
            <div className="col-12 col-md-3">
                <h3 style={{width: '100%', textAlign: 'center'}}>关注我们</h3>
                <div className="col-12" style={{textAlign: 'center'}}>
                    <a aria-label="小红书" target="_blank"
                       href="https://www.xiaohongshu.com/user/profile/5a2ddc8e4eacab0d6e53c1a4?xhsshare=CopyLink&appuid=5a2ddc8e4eacab0d6e53c1a4&apptime=1718549440&share_id=c962161a4e1b4d4d90cbb42a28bf930b"
                       style={{textDecorationLine: 'none'}}>
                        <img className="x-logo" src="/static/images/min_book.png"/>
                    </a>
                    <a aria-label="微信" href="javascript:$('#us_wechat').show()" style={{textDecorationLine: 'none'}}>
                        <img className="x-logo" src="/static/images/wechat.png"/>
                    </a>
                    <div id="us_wechat">
                        <a className="close_btn" href="javascript:$('#us_wechat').hide()">
                            <img src="/static/images/close_btn.png"/>
                        </a>
                        <img className="us_wechat" src="/static/images/us_wechat.jpg"/>
                    </div>
                </div>
            </div>
            <style
                dangerouslySetInnerHTML={{__html: "\n            #us_wechat{\n                position: absolute;\n                width:300px;\n                top: 50%;\n                left: 50%;\n                transform: translate(-50%, -50%);\n                display: none;\n            }\n            #us_wechat .close_btn img{\n                width: 32px;\n            }\n            #us_wechat .close_btn{\n                position: relative;\n                float: right;\n                top: 30px;\n\n                cursor: pointer;\n            }\n            #us_wechat .us_wechat{\n                width: 100%;\n            }\n        "}}/>
        </div>
    );
};

export default Footer;
